<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
import {OVERRIDE_LAYOUT_CONFIG} from "./store/config.module";
export default {
	name: "PSI_Portal",
	data() {
		return {
			test: false,
			authUser: false,
		};
	},
	mounted() {
		/**
		 * this is to override the layout config using saved data from sessionStorage
		 * remove this to use config only from static json (@/common/config/layout.config.json)
		 */
		this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
	},
};
</script>
